import { Box, Flex } from "@chakra-ui/react";

export const PageLayout = ({ children }) => {
  return (
    <Flex
      flex="1"
      minH="100vh"
      flexWrap="nowrap"
      flexDirection={{ base: "column", lg: "row" }}
      className="bg-white rounded-lg shadow-md my-4  "
    >
      <Box flex="1" position="relative">
        <Box
          top={{ lg: 0 }}
          left={{ lg: 0 }}
          right={{ lg: 0 }}
          bottom={{ lg: 0 }}
          className="h-full"
          overflow="auto"
          p={{ base: 4, lg: 8 }}
        >
          {children}
        </Box>
      </Box>
    </Flex>
  );
};
